import React from 'react';
function Hero() {
    return ( 
        <div className="container mt-5 mb-5 border-bottom" style={{paddingBottom:"5rem"}}>
            <div className="row text-center mt-4">
                <h3 style={{color:"#3c3c3c"}}>Open a free demat and trading account online</h3>
                <h4 className='mt-3 fs-5 text-muted' style={{color:"#3c3c3c", fontWeight:"normal"}}>Start investing brokerage free and join a community of 1.6+ crore investors and traders</h4>
            </div>
        </div>
     );
}

export default Hero;